module.exports = __webpack_public_path__ + "static/media/denver-tablet.da3c51c7.webp";